import { Employee } from "features/CenterContent/RoleContent/VehicleChecklist/hooks/useEmployeeSearch";
import {
  createSearchableSortedList,
  hasDashOrDigit,
  removeDash,
} from "features/CenterContent/RoleContent/VehicleChecklist/utils";
import { VehicleSetVariant } from "features/CenterContent/RoleContent/VehicleChecklist/VehicleSetVariant";
import { useCallback, useMemo, useState } from "react";

export const useChecklistSearch = (
  vehicleSetVariants: VehicleSetVariant[],
  employees: Employee[],
) => {
  const [searchQuery, setSearchQuery] = useState<string>("");
  const [autoCompletedQuery, setAutoCompletedQuery] = useState<string>("");

  const searchable = useMemo(
    () =>
      createSearchableSortedList(vehicleSetVariants, employees, searchQuery),
    [vehicleSetVariants, employees, searchQuery],
  );

  const handleSearchQueryChange = useCallback(
    (value: string) => {
      setSearchQuery(value);

      // Check if the search query is for vehicles or employees
      if (hasDashOrDigit(value)) {
        const filteredVariants = vehicleSetVariants.filter(
          (variant) =>
            removeDash(variant.setId).includes(removeDash(value)) ||
            removeDash(variant.setType).includes(removeDash(value)),
        );
        setAutoCompletedQuery(
          filteredVariants.map((variant) => variant.setId).join(","),
        );
      } else {
        setAutoCompletedQuery(value);
      }
    },
    [vehicleSetVariants],
  );

  return {
    searchQuery,
    autoCompletedQuery,
    searchable,
    handleSearchQueryChange,
  };
};
